import React, { useState } from 'react';
import { Form, Input, Button, Row, Col, Typography, Card, message, Modal } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { getMoreInsightsApi } from '../../services/ExperienceBankAPI';
import { useDispatch, useSelector } from 'react-redux';
import { setNotificationData } from '../../reducer/PEBCommonSlice';
import { NotificationTypes } from '../../shared/Notification/Notification';

const { Title, Text } = Typography;


const GetMoreInsights = ({ onCancel }) => {
    const [form] = Form.useForm();
    const userInfo = useSelector((state) => state.PEBCommon?.userDetail); // get User details
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        subject: '',
        question: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const onFinish = () => {
        const payload = { ...formData };
        // console.log('Payload:', payload);
        message.success('Your message has been submitted!');
    };

    const handleSubmit = async () => {
        const payload = {
            user_id: userInfo.user_id,
            email_id: formData.email,
            user_full_name: formData.fullName,
            mail_subject: formData.subject,
            ques_text: formData.question,
        };
        const response = await getMoreInsightsApi(payload);
        if (response?.status == "SUCCEEDED") {
            dispatch(
                setNotificationData({
                    type: NotificationTypes.SUCCESS,
                    duration: 5,
                    message: (
                        <>
                            <p>Message Sent Successfully</p>
                        </>
                    ),
                })
            )
        }
        else {
            dispatch(
                setNotificationData({
                    type: NotificationTypes.ERROR,
                    duration: 5,
                    message: (
                        <>
                            <p>Message sending failed! Please try again</p>
                        </>
                    ),
                })
            )
        }
        onCancel();
    }


    return (

        <div style={{ width: '94%', padding: '15px', margin: 'auto', display: 'flex', justifyContent: 'center' }}>
            <Card style={{ width: '100%', borderRadius: 12, background: 'linear-gradient(135deg, #e6f7ff, #ffffff)' }}>
                <Row gutter={[32, 32]} align="middle">
                    {/* <Col xs={24} md={12} style={{ textAlign: 'center' }}>
                                    <MailOutlined style={{ fontSize: 48, color: '#1890ff', marginBottom: 16 }} />
                                    <Title level={4}>Need More Insights on the Product?</Title>
                                    <Text>We're here to help you understand everything you need to know.</Text>
                              </Col> */}
                    <Col
                        xs={24}
                        md={12}
                        style={{
                            // background: 'linear-gradient(135deg, #e6f7ff, #ffffff)',
                            // borderRadius: '12px',
                            // padding: '40px 24px',
                            // textAlign: 'center',
                            // boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                            // display: 'flex',
                            // flexDirection: 'column',
                            // alignItems: 'center',
                            // justifyContent: 'center',
                            // height:'0%',
                            // width:'0%'
                            textAlign: 'center',
                            padding: '20px'
                        }}
                    >
                        <MailOutlined
                            style={{
                                fontSize: 56,
                                color: '#1890ff',
                                marginBottom: 20,
                                animation: 'pulse 1.8s infinite',
                            }}
                        />
                        <Title level={3} style={{ marginBottom: 12 }}>Need More Insights?</Title>
                        <Text style={{ fontSize: 16, color: '#595959', maxWidth: '50%' }}>
                            We're here to help you understand everything you need to know. Reach out to us anytime!
                        </Text>

                        <style>
                            {`
                                @keyframes pulse {
                                    0% { transform: scale(1); opacity: 1; }
                                    50% { transform: scale(1.1); opacity: 0.9; }
                                    100% { transform: scale(1); opacity: 1; }
                                }
                                `}
                        </style>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form
                            layout="vertical"
                            form={form}
                            // onFinish={onFinish}
                            onFinish={handleSubmit}
                            initialValues={formData}
                            style={{ padding: '20px' }}
                        >
                            <Form.Item
                                label="Full Name"
                                name="fullName"
                                rules={[
                                    { required: true, message: 'Please enter your full name' },
                                    { min: 2, message: 'Name must be at least 2 characters' },
                                    { max: 50, message: 'Name can be at most 50 characters' },
                                ]}
                            >
                                <Input
                                    name="fullName"
                                    placeholder="e.g., John Doe"
                                    onChange={handleInputChange}
                                />
                            </Form.Item>

                            <Form.Item
                                label="Email Address"
                                name="email"
                                rules={[
                                    { required: true, message: 'Please enter your email address' },
                                    { type: 'email', message: 'Please enter a valid email address' },
                                    { min: 5, message: 'Email must be at least 5 characters' },
                                    { max: 100, message: 'Email can be at most 100 characters' },
                                ]}
                            >
                                <Input
                                    name="email"
                                    placeholder="e.g., john@example.com"
                                    onChange={handleInputChange}
                                />
                            </Form.Item>

                            <Form.Item
                                label="Subject"
                                name="subject"
                                rules={[
                                    { required: true, message: 'Please enter a subject' },
                                    { min: 3, message: 'Subject must be at least 3 characters' },
                                    { max: 200, message: 'Subject can be at most 200 characters' },
                                ]}
                            >
                                <Input
                                    name="subject"
                                    placeholder="e.g., Inquiry about product features"
                                    onChange={handleInputChange}
                                />
                            </Form.Item>

                            <Form.Item
                                label="Your Question"
                                name="question"
                                rules={[
                                    { required: true, message: 'Please enter your question' },
                                    { min: 3, message: 'Question must be at least 3 characters' },
                                    { max: 1000, message: 'Question can be at most 1000 characters' },
                                ]}
                            >
                                <Input.TextArea
                                    name="question"
                                    rows={6}
                                    placeholder="Let us know how we can help you"
                                    onChange={handleInputChange}
                                />
                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" htmlType="submit" block >
                                    Send Message
                                </Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
            </Card>
        </div>

    );
};

export default GetMoreInsights;